(function () {
    'use strict';

    angular.module("imApp").factory("requisitionsBetweenService", ['$ihttp', function ($ihttp) {
        let service = {
            getSetting: function (parms) {
                return $ihttp.post({
                    method: 766,
                    parameters: parms || {}
                });
            },
            listRequisitionsBetween: function (parms) {
                return $ihttp.post({
                    method: 767,
                    parameters: parms || {}
                });
            },
            listRequisitionsBetweenConsignment: function (parms) {
                return $ihttp.post({
                    method: 776,
                    parameters: parms || {}
                });
            }
        };

        return service;
    }]);
})();
